import { setLoading } from "../redux/app_global/reducer";
import { setLoading as setLoadingAdvertisement, setAdvertisement_id, setAdvertisement_list, setAdvertisement_my } from "../redux/advertisement/reducer";
import Request, { RequestFile } from "./handler.js";

export const getAdvertisementSeo = async (data) => {
    var result = {};
    
    data.method = 'advertisement_seo';

    await Request(data, 'post')
    .then(async json => {
        result = json;
    });

    return result;
}

export const getAdvertisementList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setAdvertisement_list(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const getAdvertisementMy = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_my';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setAdvertisement_my(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const getAdvertisementId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'advertisement_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            if (Object.keys(json?.result).length > 0) {
                json.result['error_code'] = 200;
                await dispatch(setAdvertisement_id(json?.result));
            } else {
                await dispatch(setAdvertisement_id({error_code:404}));
            }
        }

        result = json;
    });

    return result;
}

export const addAdvertisement = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const updAdvertisementData = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_upd_data';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const updAdvertisementContent = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_upd_content';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const updAdvertisementModeration = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_upd_moderation';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const updAdvertisementTempDraft = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_upd_draft_temp';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const updAdvertisementPublish = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_upd_publish';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const updAdvertisementUp = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_upd_up';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}

export const updAdvertisementLocation = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingAdvertisement(true));
    data.method = 'advertisement_upd_location';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingAdvertisement(false));

    return result;
}